module.exports = __webpack_public_path__ + "img/Human_symbol_1.a3766ef9.png";